import { useState } from 'react';
import { HeaderPage } from '@client/new/pages/layouts';
import { OTPLandingPageBuilder } from './OTPLandingPageBuilder';
import { Typography } from '@design-system/components/typography/typography';
import { BackButton } from '@client/new/pages/collection/program';
import { Button } from '@design-system/components/button/button';
import { OfferDisplayUpgradeModal } from './OfferDisplayUpgradeModal';

export const OfferLandingPageBuilder = (p: {
  params: { influencerId: string; offerId: string };
}) => {
  const [offerName, setOfferName] = useState<string | null>(null);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  const headerTitle = offerName ? `Offer: ${offerName}` : 'Offer Landing Page';

  return (
    <HeaderPage
      header={
        <>
          <div className="flex items-center gap-5">
            <BackButton />
            <Typography variant="headline" size="large" id="page-title">
              {headerTitle}
            </Typography>
          </div>
          <Button
            color="primaryTonal"
            onClick={() => setIsUpgradeModalOpen(true)}
          >
            See what changed in Offer Landing Page builder
          </Button>
        </>
      }
    >
      <div className="pt-8">
        <OTPLandingPageBuilder
          embedded
          params={{
            influencerId: p.params.influencerId,
            offerId: p.params.offerId,
            programId: '0',
          }}
          onOfferNameChange={setOfferName}
        />
      </div>
      <OfferDisplayUpgradeModal
        isOpen={isUpgradeModalOpen}
        onClose={() => setIsUpgradeModalOpen(false)}
      />
    </HeaderPage>
  );
};
